"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._constructTemporalPlainTime = exports.getPlainTime = void 0;
var js_temporal_polyfill_1 = require("@mishakanai/js-temporal-polyfill");
var utils_1 = require("../util/utils");
function getPlainTime(plainDateInput) {
    if (typeof plainDateInput === 'string') {
        return _constructTemporalPlainTime(plainDateInput);
    }
    return plainDateInput._getTemporalPlainTime();
}
exports.getPlainTime = getPlainTime;
function constructFrom(hour, minute, maybeAmPm) {
    var parsedHour = (0, utils_1.parseNum)(hour);
    if (parsedHour >= 24) {
        throw new Error('invalid usage.');
    }
    var parsedMinute = (0, utils_1.parseNum)(minute);
    if (parsedMinute >= 60) {
        throw new Error('invalid usage.');
    }
    var amPm = maybeAmPm !== null && maybeAmPm !== void 0 ? maybeAmPm : 'mil';
    var validAmPms = ['am', 'pm', 'mil'];
    if (!validAmPms.includes(amPm)) {
        throw new Error('invalid usage.');
    }
    if ([parsedHour, parsedMinute].some(function (n) { return isNaN(n); })) {
        throw new Error('invalid usage.');
    }
    if (amPm === 'pm' && parsedHour < 12) {
        parsedHour += 12;
    }
    var plainTime = new js_temporal_polyfill_1.Temporal.PlainTime(parsedHour, parsedMinute);
    return plainTime;
}
function _constructTemporalPlainTime(arg1, arg2, arg3) {
    var _a, _b;
    if (typeof arg2 !== 'undefined') {
        if (typeof arg1 === 'object') {
            // add option to chain if invalid.
            throw new Error('invalid usage.');
        }
        return constructFrom(arg1, arg2, arg3);
    }
    var milTimeRx = /^(2[0-3]|[0-1]?[\d]):([0-5][\d])$/;
    var amPmTimeRx = /^(10|11|12|[1-9]):([0-5][0-9])\s*(am|pm)$/i;
    /**
     * Let's say for now that arg1 can be
     * 12:00(optional whitespace)[am/pm/AM/PM]?
     */
    if (typeof arg1 === 'string') {
        var milTimeMatches = Array.from((_a = arg1.match(milTimeRx)) !== null && _a !== void 0 ? _a : []);
        if ((milTimeMatches === null || milTimeMatches === void 0 ? void 0 : milTimeMatches.length) === 3) {
            var _c = milTimeMatches.slice(1).map(function (group) { return (0, utils_1.parseNum)(group); }), hour24 = _c[0], minute = _c[1];
            if (!isNaN(hour24) && !isNaN(minute)) {
                return new js_temporal_polyfill_1.Temporal.PlainTime(hour24, minute);
            }
        }
        var amPmMatches = Array.from((_b = arg1.match(amPmTimeRx)) !== null && _b !== void 0 ? _b : []);
        if ((amPmMatches === null || amPmMatches === void 0 ? void 0 : amPmMatches.length) === 4) {
            var _d = amPmMatches.slice(1), hourStr = _d[0], minuteStr = _d[1], ampm = _d[2];
            var hour = (0, utils_1.parseNum)(hourStr);
            var minute = (0, utils_1.parseNum)(minuteStr);
            if (!isNaN(hour) && !isNaN(minute)) {
                if (ampm.toLowerCase() === 'pm' && hour < 12) {
                    hour += 12;
                }
                return new js_temporal_polyfill_1.Temporal.PlainTime(hour, minute);
            }
        }
    }
    if (arg1 && typeof arg1 === 'object') {
        return constructFrom(arg1.hour, arg1.minute, arg1.amPm);
    }
    return null;
}
exports._constructTemporalPlainTime = _constructTemporalPlainTime;
//# sourceMappingURL=util.js.map